import { useContext } from 'react';
import { Sidebar, SidebarLink, SidebarDivider, SidebarContext } from '@ka/webcomponents/nav';
import { useUser } from '../../userAccess/useUser';
import { SiteUserRole } from '../../userAccess/UserContext';
import { KahlerLogo } from '../../common/KahlerLogo';

const SiteLinks = () => {
  const user = useUser();
  if (user.selectedSite == null) return null;

  const isAdmin = user.selectedSite.role === SiteUserRole.Admin;
  const useStagedPurchaseOrders = user.selectedSite.enablePurchaseOrders;

  return <>
    <SidebarLink to="/stagedOrders" icon="file-ruled" label="Staged Orders" />
    {isAdmin && useStagedPurchaseOrders && <SidebarLink to="/stagedPurchaseOrders" icon="cart" label="Staged Purchase Orders" />}
    {isAdmin && <>
      <SidebarLink to="/orderHistory" icon="clock-history" label="Order History" />
      <SidebarDivider />
      <SidebarLink to="/carrierDriverSettings" icon="person-badge" label="Carrier/Driver Info" />
      <SidebarLink to="/customerDestination" icon="map" label="Customer Destination" />
      <SidebarLink to="/scaleAutomation" icon="clipboard-check" label="Scale Automation" />
      <SidebarLink to="/loadQuestions" icon="question-circle" label="Load Questions" />
      <SidebarLink to="/bayDirections" icon="signpost" label="Bay Directions" />
      <SidebarLink to="/bayDirectionsValidation" icon="check2-square" label="Bay Directions Validation" />
      <SidebarLink to="/kioskManagement" icon="shop-window" label="Kiosk Management" />
      <SidebarLink to="/loadConfiguration" icon="sliders" label="Load Configuration" />
      <SidebarLink to="/businessHours" icon="calendar-week" label="Business Hours" />
      <SidebarLink to="/users" icon="person-lines-fill" label="Users" />
      <SidebarLink to="/generalSettings" icon="gear" label="General" />
    </>}
  </>;
};

export function AdminNavSideMenu() {
  const { isCollapsed, toggleSidebar } = useContext(SidebarContext);

  return (
    <Sidebar
      collapsed={isCollapsed}
      onToggle={toggleSidebar}
      footer={<KahlerLogo isCollapsed={isCollapsed} />}>
      <SiteLinks />
    </Sidebar>
  );
}
